module.exports = __webpack_public_path__ + "static/media/2_11.b2fd4b25.png";